import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { SegmentCardChecklistCloseSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onCloseEvents = (
    isChecklist: boolean,
    isEsc: boolean
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (isChecklist) {
            dispatch(segmentTrackAction(SegmentCardEvent.CHECKLIST_WITHOUT_ITEMS_DELETED, {
                name: SegmentCardOptions.SOURCE,
                value: isEsc ? SegmentCardChecklistCloseSourceValue.ESC : SegmentCardChecklistCloseSourceValue.INPUT_CLOSED
            }))
        } else {
            dispatch(segmentTrackAction(SegmentCardEvent.NEW_CHECKLIST_ITEM_CREATION_INPUT_CLOSED, {
                name: SegmentCardOptions.SOURCE,
                value: isEsc ? SegmentCardChecklistCloseSourceValue.ESC : SegmentCardChecklistCloseSourceValue.INPUT_CLOSED
            }))
        }
    };
    return action;
};
